<template>
  <div class="has-return">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item style="float: right; margin-right: 0" v-if="funcView.free_accessories_order_export">
          <el-button class="table-set" @click="exportTable">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right" :class="{ 'mr-0': !funcView.free_accessories_order_export }">
          <search-input v-model="formSearch.search" :placeholder="$t('crm_has_return.ji_shen_hao')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <!-- 高级搜索 -->
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('crm_has_return.chan_pin_xing_hao')">
          <custom-select url="productCodeSelectList" v-model="formSearch.productCode" :props="{ label: 'productCode', value: 'productCode' }" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('crm_has_return.zeng_song_pei_jian')">
          <el-input v-model="formSearch.partCodeName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm_has_return.he_tong_bian_hao')">
          <el-input v-model="formSearch.contractNo"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm_has_return.shou_hou_gong_si')">
          <el-input v-model="formSearch.afterServiceName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm_has_return.cao_zuo_ri_qi')">
          <custom-date-picker
            style="width: 100%"
            @change="onPageChange({ page: 1 })"
            v-model="formSearch.cancelDate"
            type="daterange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('crm_has_return.qrskrq')">
          <custom-date-picker
            style="width: 100%"
            @change="onPageChange({ page: 1 })"
            v-model="formSearch.finalPayment"
            type="daterange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('crm_has_return.chuang_jian_ri_qi')">
          <custom-date-picker
            style="width: 100%"
            @change="onPageChange({ page: 1 })"
            v-model="formSearch.gmtCreate"
            type="daterange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('crm_has_return.xiang_mu_ming_cheng')">
          <el-input v-model="formSearch.locationName"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        tableCode="free_part_order_has_cancel"
        ref="table"
        :data="tableList"
        height="100%"
        @filter="filterChange"
        @sort="sortChange"
        @column="setColumn"
        :slots="['orderGoodsCode', 'contractNo', 'billTermNum']"
      >
        <template v-slot:orderGoodsCode="scope">
          <span v-if="funcView.free_accessories_order_order_detail" class="cell-link" @click.stop="showDetail(scope.row)">{{ scope.row.orderGoodsCode }}</span>
          <span v-else>{{ scope.row.orderGoodsCode }}</span>
        </template>
        <template v-slot:contractNo="scope">
          <span class="cell-link" @click="toContractDetail(scope.row)">{{ scope.row.contractNo || '-' }}</span>
        </template>
        <template v-slot:billTermNum="scope">
          <div>
            {{ scope.row.billTermNum ? `${scope.row.billTermNum}/${scope.row.billTotalTerm}` : '-' }}
          </div>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <div class="table-sum-params">
        <div class="sum-item">
          <div class="key">{{ $t('crm_has_return.zpjsl') }}：</div>
          <div class="val selected-num">{{ totalPartNum }}</div>
        </div>
      </div>
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <part-order-detail-dialog v-if="detailVisible" @close="detailVisible = false" :model="detailModel" @infoChange="getTableList"></part-order-detail-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import partOrderDetailDialog from '@/pages/crm/components/part_order_detail_dialog.vue';
import mixins from './mixins.js';

export default {
  name: '',
  mixins: [mixins],
  components: {
    partOrderDetailDialog,
  },
  props: {},
  data() {
    return {
      formSearch: {
        search: '',
        pageSize: 50,
        pageNum: 1,

        //  产品型号、赠送配件、合同编号、售后公司、作废日期

        // 产品型号
        productCode: '',

        // 赠送配件
        partCodeName: '',

        // 合同编号
        contractNo: '',

        // 售后公司
        afterServiceName: '',

        // 作废日期
        cancelDate: '',
        // 最终支付日期
        finalPayment: '',
        // 创建日期
        gmtCreate: '',
        // 项目名称
        locationName: '',
      },
      link: null,

      tableList: [],
      tableSelect: [],

      totalRows: null,

      // 总配件数
      totalPartNum: 0,

      // 配送订单详情
      detailVisible: false,
      detailModel: {},
    };
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {
    // 配送订单详情
    showDetail(row) {
      this.detailModel = {
        title: row.orderGoodsCode,
        data: row,
      };
      this.detailVisible = true;
    },

    getReqData() {
      const { cancelDate } = this.formSearch;
      const reqData = { ...this.formSearch };
      if (cancelDate && cancelDate.length) {
        reqData.stateChangeStartDate = cancelDate[0];
        reqData.stateChangeEndDate = cancelDate[1];
      }
      delete reqData.cancelDate;
      const { finalPayment } = this.formSearch;
      if (finalPayment && finalPayment.length) {
        reqData.finalPaymentStartTime = finalPayment[0];
        reqData.finalPaymentEndTime = finalPayment[1];
      }
      delete reqData.finalPayment;
      const { gmtCreate } = this.formSearch;
      if (gmtCreate && gmtCreate.length) {
        reqData.createStartTime = gmtCreate[0];
        reqData.createEndTime = gmtCreate[1];
      }
      delete reqData.gmtCreate;
      return reqData;
    },

    getTableList() {
      const reqData = this.getReqData();
      this.$getJSON(apis.giveawayPage, reqData).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
      this.$getJSON(apis.giveawayCount, reqData).then((res) => {
        this.totalPartNum = res.data || 0;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    clearFilter: function () {
      this.$refs.table.clearFilter();
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.onPageChange({ page: 1 });
    },
    exportTable() {
      const data = this.getReqData();
      delete data.pageNum;
      delete data.pageSize;

      this.$exportFlie(apis.giveawayExport, data).catch(() => {
        this.$message({
          message: this.$t('crm_has_return.cao_zuo_shi_bai'),
          type: 'error',
        });
      });
    },
  },
  created() {},
  mounted() {
    this.getDicMap('giveaway_biz_state', () => {
      this.formSearch.type = [this.dicMap.giveaway_biz_state.returned];
      this.resetFormSearch = JSON.stringify(this.formSearch);
      this.getFuncView(null, () => {
        setTimeout(() => {
          this.link = this.$refs.container;
        }, 500);
      });

      this.getTableList();
    });
  },
};
</script>

<style lang="scss" scoped>
.has-return {
  flex: 1;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.table-sum-params {
  float: left;
  overflow: hidden;

  .selected-num {
    padding: 0 5px;
    color: #0d9ae0;
  }

  .sum,
  .price {
    color: #0d9ae0;
  }

  .ml-10 {
    margin-left: 10px;
  }

  .sum-item {
    float: left;
    line-height: 32px;
    font-size: 12px;
    color: #606266;

    .key,
    .val {
      float: left;
    }
  }
}
</style>
